export interface TierRate {
  hourly: number;
  halfHourly: number;
}

export interface ServiceRates {
  handyman: TierRate;
  plumbing: TierRate;
  electrical: TierRate;
  cleaning: TierRate;
}

export interface TierRates {
  tier1: ServiceRates;
  tier2: ServiceRates;
  tier3: ServiceRates;
}

export const providerTierRates: TierRates = {
  tier1: {
    handyman: {
      hourly: 55,
      halfHourly: 27.5,
    },
    plumbing: {
      hourly: 80,
      halfHourly: 40,
    },
    electrical: {
      hourly: 75,
      halfHourly: 37.5,
    },
    cleaning: {
      hourly: 35,
      halfHourly: 17.5,
    },
  },
  tier2: {
    handyman: {
      hourly: 45,
      halfHourly: 22.5,
    },
    plumbing: {
      hourly: 70,
      halfHourly: 35,
    },
    electrical: {
      hourly: 65,
      halfHourly: 32.5,
    },
    cleaning: {
      hourly: 32,
      halfHourly: 16,
    },
  },
  tier3: {
    handyman: {
      hourly: 40,
      halfHourly: 20,
    },
    plumbing: {
      hourly: 60,
      halfHourly: 30,
    },
    electrical: {
      hourly: 55,
      halfHourly: 27.5,
    },
    cleaning: {
      hourly: 30,
      halfHourly: 15,
    },
  },
};

export const AFTER_HOURS_UPLIFT = 0.2; // 20%
export const LATE_CALLOUT_FEE = 50; // £50
export const PLATFORM_FEE = 0.15; // 15%

export function getCityTierRates(
  cityName: string,
  tradeType: string
): {
  tier: string;
  tierNumber: number;
  normalHourly: number;
  normalHalfHourly: number;
  afterHoursHourly: number;
  afterHoursHalfHourly: number;
  lateCalloutFee: number;
  providerEarningsPercent: number;
} | null {
  const cityLower = cityName.toLowerCase();
  
  let tier: 'tier1' | 'tier2' | 'tier3';
  let tierNumber: number;
  let tierName: string;

  // Tier 1 - London
  if (cityLower === 'london') {
    tier = 'tier1';
    tierNumber = 1;
    tierName = 'Tier 1 (London)';
  }
  // Tier 2 - Major UK Cities
  else if (
    ['birmingham', 'manchester', 'leeds', 'liverpool', 'bristol', 'glasgow', 'edinburgh', 'newcastle'].includes(cityLower)
  ) {
    tier = 'tier2';
    tierNumber = 2;
    tierName = 'Tier 2 (Major Cities)';
  }
  // Tier 3 - Wales
  else if (['cardiff', 'newport', 'swansea'].includes(cityLower)) {
    tier = 'tier3';
    tierNumber = 3;
    tierName = 'Tier 3 (Wales)';
  } else {
    return null;
  }

  const tradeLower = tradeType.toLowerCase();
  let rates: TierRate;

  if (tradeLower.includes('handyman')) {
    rates = providerTierRates[tier].handyman;
  } else if (tradeLower.includes('plumb')) {
    rates = providerTierRates[tier].plumbing;
  } else if (tradeLower.includes('electric')) {
    rates = providerTierRates[tier].electrical;
  } else if (tradeLower.includes('clean')) {
    rates = providerTierRates[tier].cleaning;
  } else {
    return null;
  }

  const afterHoursMultiplier = 1 + AFTER_HOURS_UPLIFT;
  const providerEarningsPercent = (1 - PLATFORM_FEE) * 100;

  return {
    tier: tierName,
    tierNumber,
    normalHourly: rates.hourly,
    normalHalfHourly: rates.halfHourly,
    afterHoursHourly: rates.hourly * afterHoursMultiplier,
    afterHoursHalfHourly: rates.halfHourly * afterHoursMultiplier,
    lateCalloutFee: LATE_CALLOUT_FEE,
    providerEarningsPercent,
  };
}
